import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Constrain from '../components/Constrain';
import './index.css';

import favicon from '../images/idea-in-hand.jpg';

const TemplateWrapper = ({ children }) => (
    <div>
        <Helmet>
            <link rel="stylesheet" href="https://use.typekit.net/djl2pdv.css" />
        </Helmet>
        <Header />
        {children()}
        <Footer />
    </div>
)

TemplateWrapper.propTypes = {
    children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js